<!-- KPI card: single dataset, one column aggregated (sum / distinct / …) to
     a single headline value. -->
<div class="wf-section" *ngIf="active">
  <header class="wf-section-header">
    <h3>{{ host.layoutSectionTitle('kpi', 'KPI card') }}</h3>
  </header>
  <small class="control-hint" *ngIf="host.layoutSectionHint('kpi')">{{ host.layoutSectionHint('kpi') }}</small>
  <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>

  <div class="control-row">
    <div class="control-group wf-field-drop-zone" (dragover)="host.allowFieldDrop($event)" (drop)="onKpiFieldDrop($event)" title="Drag a column here">
      <label>{{ host.fieldLabel('kpi', 'field', 'Column') }}</label>
      <ng-select
        #ssKpiField
        class="ss-select"
        [class.is-open]="!!ssKpiField.isOpen?.()"
        appendTo="body"
        ngClass="ss-dropdown-panel"
        [items]="host.drillDatasetColumns"
        [clearable]="true"
        [searchable]="true"
        [loading]="host.isDrillDatasetColumnsLoading"
        [disabled]="!host.drillDataset"
        [placeholder]="host.drillColumnPlaceholder('measure')"
        [ngModel]="kpiField || null"
        (ngModelChange)="kpiField = $event || ''"
      ></ng-select>
    </div>
    <div class="control-group">
      <label>{{ host.fieldLabel('kpi', 'aggregation', 'Aggregation') }}</label>
      <ng-select
        #ssKpiAgg
        class="ss-select"
        [class.is-open]="!!ssKpiAgg.isOpen?.()"
        appendTo="body"
        ngClass="ss-dropdown-panel"
        [items]="kpiAggregations"
        bindLabel="label"
        bindValue="value"
        [clearable]="true"
        [ngModel]="kpiAggregation"
        (ngModelChange)="kpiAggregation = $event ?? ''"
      ></ng-select>
    </div>
  </div>
  <div class="control-row" *ngIf="host.fieldEnabled('kpi', 'formula')">
    <div class="control-group control-group-full wf-field-drop-zone" (dragover)="host.allowFieldDrop($event)" (drop)="onKpiFormulaFieldDrop($event)" title="Drag a column here">
      <label>{{ host.fieldLabel('kpi', 'formula', 'Formula (optional)') }}</label>
      <input type="text" [(ngModel)]="kpiFormula" placeholder="e.g. [price] * [qty] — overrides Column + Aggregation when set" />
    </div>
  </div>

  <!-- References: when the formula's [Token] isn't a plain dataset column
       but another input's live/recomputed output, type in where it comes
       from so the backend resolves the CURRENT value instead of a stale
       one. Keyed by THIS KPI's own componentId. -->
  <ng-container *ngIf="host.fieldEnabled('kpi', 'formula') && host.formulaReferencesEnabledFor('KPI')">
    <ng-container *ngTemplateOutlet="referenceList; context: { id: host.componentId }"></ng-container>
  </ng-container>

  <!-- Value colour rules: colour the headline value when it meets a
       condition (e.g. less than 20000 → yellow). Same rule model as the
       table cell formatting; first matching rule wins. -->
  <div class="control-row" *ngIf="host.fieldEnabled('kpi', 'valueRules')">
    <div class="control-group control-group-full">
      <div class="kpi-rules-head">
        <label>{{ host.fieldLabel('kpi', 'valueRules', 'Value colour rules') }}</label>
        <button type="button" class="kpi-rules-add" (click)="addValueRule()">+ Add rule</button>
      </div>
      <small class="control-hint" *ngIf="!valueRules.length">Colour the value when it meets a condition, e.g. Less than 20000 → yellow. Rules are checked top to bottom; the first match wins.</small>
      <div class="kpi-rule" *ngFor="let rule of valueRules; let i = index">
        <!-- Line 1: rule number, condition, remove. -->
        <div class="kpi-rule-line">
          <span class="kpi-rule-index">{{ i + 1 }}</span>
          <ng-select
            #ssKpiRuleOp
            class="ss-select kpi-rule-op"
            [class.is-open]="!!ssKpiRuleOp.isOpen?.()"
            appendTo="body"
            ngClass="ss-dropdown-panel"
            [items]="valueRuleOperators"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [searchable]="false"
            [ngModel]="rule.op"
            (ngModelChange)="setValueRule(rule, 'op', $event)"
          ></ng-select>
          <button type="button" class="kpi-rule-x kpi-rule-x-del" (click)="removeValueRule(i)" title="Remove rule">✕</button>
        </div>
        <!-- Line 2: compared value(s), colour, reorder. -->
        <div class="kpi-rule-line kpi-rule-line-2">
          <input *ngIf="ruleTakesValue(rule)" type="text" class="kpi-rule-value" [ngModel]="rule.value ?? ''" (ngModelChange)="setValueRule(rule, 'value', $event)" [placeholder]="rule.op === 'between' ? 'From, e.g. 0' : 'e.g. 20000'" />
          <input *ngIf="rule.op === 'between'" type="text" class="kpi-rule-value" [ngModel]="rule.value2 ?? ''" (ngModelChange)="setValueRule(rule, 'value2', $event)" placeholder="To, e.g. 20000" />
          <span class="kpi-rule-color" title="Value colour when this rule matches">
            <input type="color" [value]="rule.color || '#f59e0b'" (input)="setValueRule(rule, 'color', $any($event.target).value)" />
            <span class="kpi-rule-hex">{{ rule.color || '#f59e0b' }}</span>
          </span>
          <span class="kpi-rule-actions">
            <button type="button" class="kpi-rule-x" (click)="moveValueRule(i, -1)" [disabled]="i === 0" title="Move up">↑</button>
            <button type="button" class="kpi-rule-x" (click)="moveValueRule(i, 1)" [disabled]="i === valueRules.length - 1" title="Move down">↓</button>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Format accordions (registry `sections`-gated; shell formatControls) -->
  <ng-container [ngTemplateOutlet]="chartFormatAccordion"></ng-container>
</div>
